import React, { useState, useEffect } from "react";

const SubscribeButton = ({ initialSubscribed = false }) => {
  const [subscribed, setSubscribed] = useState(false);

  useEffect(() => {
    setSubscribed(initialSubscribed); // если проп изменится — применим
  }, [initialSubscribed]);

  const toggleSubscribe = () => {
    setSubscribed((prev) => !prev);
  };

  return (
    <button
      className={`btn btn-sub sub ${subscribed ? "" : "btn-black"}`}
      onClick={toggleSubscribe}
    >
      {subscribed ?
      <svg
        width="16"
        height="12"
        viewBox="0 0 16 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.258 0.829631C15.5823 1.1562 15.5804 1.68383 15.2539 2.00813L6.0231 11.1748C5.69814 11.4975 5.17366 11.4975 4.8487 11.1748L0.746134 7.10073C0.419566 6.77643 0.417727 6.24879 0.742028 5.92222C1.06633 5.59565 1.59396 5.59382 1.92053 5.91812L5.4359 9.40907L14.0795 0.825524C14.406 0.501223 14.9337 0.503062 15.258 0.829631Z"
          fill="#191A21"
        />
      </svg> : ""
      }
      {subscribed ? "Подписаны" : "Подписаться"}
    </button>
  );
};

export default SubscribeButton;
